<template>
    <div class="[ mk-artwork-share-perspective ] row">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4 mx-auto px-0 ">

            <div class="[ perspective-divider ] my-4"></div>

            <div>
                <h1
                    class="ml-0 font-secondary"
                    :class="questionFocused ? 'perspective-q-focused' : ''"
                    style="margin-bottom: 40px; line-height: 33px; transition: var(--all-3);"
                >
                    <nl2br tag="span" :text="artwork.question" />
                </h1>

                <div class="cursor">
                    <v-textarea
                        v-model="form.comment"
                        class="text-field perspective-textarea"
                        placeholder="Share your perspective"
                        rows="1"
                        no-resize
                        auto-grow
                        @focus="questionFocused = true"
                        @blur="questionFocused = false"
                        @click="questionFocused = true"
                        ref="commentRef"
                    ></v-textarea>
                    <i v-if="isIos && form.comment == ''"></i>
                </div>

                <button
                    @click="handleShare"
                    text
                    class="btn [ btn-white-pill ]"
                    style="margin-top: 27px;"
                >
                    Share
                </button>
            </div>

            <div class="[ perspective-divider ] my-4"></div>

            <div style="margin-bottom: 40px;">
                <h3 class="mb-3 fw-700" ><u @click="showPerspective" class="font-secondary cursor-pointer">Skip to view other perspectives</u></h3>

                <p class="mb-0 fs-14 color-200-placeholder font-secondary" style="line-height: 16px;">If you skip now, you will not be able to contribute your perspective later.</p>
            </div>
        </div>

    </div>
</template>





<style>
.cursor {
    position: relative;
}
.cursor i {
    position: absolute;
    width: 2px;
    height: 50%;
    background-color: #fff;
    left: 0;
    top: 3px;
    animation-name: blink;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    opacity: 1;
}

.cursor textarea:focus + i {
    display: none;
}

@keyframes blink {
    from { opacity: 1; }
    to { opacity: 0; }
}

.perspective-q-focused {
    opacity: 0.5;
}

.perspective-textarea {
    padding-top: 0;
    margin-top: 0;
    font-size: 28px !important;
    line-height: 33px !important;
    font-weight: 700;
}

.perspective-textarea.v-textarea .v-input__slot {
    background-color: transparent !important;
    border: none !important
}

.perspective-textarea.v-textarea .v-input__slot::before,
.perspective-textarea.v-textarea .v-input__slot::after {
    display: none !important;
}

.perspective-textarea.v-textarea .v-input__slot textarea {
    font-family: var(--font-secondary) !important;
    line-height: 33px !important;
}

.perspective-textarea.v-textarea .v-input__slot textarea::placeholder {
    font-size: 28px;
    color: rgba(255, 255, 255, 0.5) !important;
}
</style>


<script>
import axios from 'axios';



export default {
    props: {
        artwork: {
            type: Object,
        },
    },
    mounted() {
        this.$refs.commentRef.focus();
        this.questionFocused = false;
        this.hideFooter();
    },
    data() {
        return {
            form: {
                artwork_id: this.artwork.id ? this.artwork.id : '',
                comment: '',
                is_published: false
            },
            questionFocused: false,
            isIos: navigator.userAgent.match(/(iPod|iPhone|iPad)/)
        };
    },
    methods: {
        async handleShare() {

            await axios
                .post('/api/v1/frontend/artwork_answers', this.form)
                .then((response) => {
                    this.form.comment = '';
                    this.showFooter();
                    this.showPerspective();
                })
                .catch(function (e) {
                    if (e.response.status == 422) {
                        var errorText = "";
                        if (e.response.data.errors) {
                        Object.entries(e.response.data.errors).forEach(([key, value]) => {
                            value.forEach((errorMessage) => {
                            errorText += "" + errorMessage + " <br>";
                            });
                        });
                        } else {
                        errorText += e.response.data.message;
                        }
                        Vue.swal("", errorText, "error");
                        return e.response;
                    } else if(e.response.status == 413) {
                        Vue.swal("", "Server Error Request Entity Too Large", "error");
                    } else {
                        Vue.swal("", "Server error", "error");
                    }
                });
        },
        showPerspective() {
            this.$parent.showShare = false;
            this.$parent.showPerspective = true;
            this.showFooter();
        },
        hideFooter: function(){
            const footer = document.querySelector("#app > main > div > div > div > footer");
            footer.style.display = "none";
        },
        showFooter: function(){
            const footer = document.querySelector("#app > main > div > div > div > footer");
            footer.style.display = "block";
        }
    }
};
</script>
